import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-55">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-56">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="bg-[#15151e] border border-gray-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-57">
            <div className="flex items-center justify-between p-6 border-b border-gray-800" data-id="element-58">
              <h2 className="text-xl font-bold text-white" data-id="element-59">{title}</h2>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-colors" aria-label="Cerrar" data-id="element-60">
                <X className="w-5 h-5" data-id="element-61" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-62">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="py-8 px-4 bg-[#050508] border-t border-gray-900 text-center" data-id="element-63">
        <div className="max-w-4xl mx-auto" data-id="element-64">
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-65">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 text-sm hover:text-blue-400 transition-colors underline underline-offset-2" data-id="element-66">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-67">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 text-sm hover:text-blue-400 transition-colors underline underline-offset-2" data-id="element-68">
              Términos de Servicio
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-69">
        <p data-id="element-70">
          <strong className="text-white" data-id="element-71">Última actualización:</strong> Abril
          2025
        </p>

        <p data-id="element-72">
          En Facebook Ads Andrómeda, nos comprometemos a proteger tu privacidad.
          Esta política describe cómo recopilamos, usamos y protegemos tu
          información personal cuando visitas nuestro sitio web o adquieres
          nuestros productos digitales.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-73">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-74">
          Podemos recopilar la siguiente información cuando realizas una compra
          o interactúas con nuestro sitio:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-75">
          <li data-id="element-76">Nombre completo</li>
          <li data-id="element-77">Dirección de correo electrónico</li>
          <li data-id="element-78">Información de pago (procesada de forma segura por Hotmart)</li>
          <li data-id="element-79">Dirección IP y datos de navegación</li>
        </ul>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-80">
          2. Uso de la Información
        </h3>
        <p data-id="element-81">Utilizamos tu información para:</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-82">
          <li data-id="element-83">Procesar y entregar tu compra</li>
          <li data-id="element-84">Enviarte el producto digital adquirido</li>
          <li data-id="element-85">Comunicarnos contigo sobre tu pedido</li>
          <li data-id="element-86">Mejorar nuestros productos y servicios</li>
          <li data-id="element-87">Cumplir con obligaciones legales</li>
        </ul>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-88">
          3. Protección de Datos
        </h3>
        <p data-id="element-89">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-90">4. Terceros</h3>
        <p data-id="element-91">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación de nuestro sitio web y procesamiento de pagos
          (como Hotmart), siempre que dichas partes acuerden mantener esta
          información confidencial.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-92">
          5. Cookies y Tecnologías de Seguimiento
        </h3>
        <p data-id="element-93">
          Utilizamos cookies y tecnologías similares (incluyendo el Pixel de
          Meta) para mejorar la experiencia del usuario, analizar el tráfico del
          sitio y personalizar contenido publicitario. Puedes configurar tu
          navegador para rechazar cookies, aunque esto puede afectar la
          funcionalidad del sitio.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-94">
          6. Tus Derechos
        </h3>
        <p data-id="element-95">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal. Para ejercer estos derechos, contáctanos a través de
          nuestros canales de comunicación.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-96">
          7. Cambios a esta Política
        </h3>
        <p data-id="element-97">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta página con la
          fecha de actualización correspondiente.
        </p>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" data-id="element-98">
        <p data-id="element-99">
          <strong className="text-white" data-id="element-100">Última actualización:</strong> Abril
          2025
        </p>

        <p data-id="element-101">
          Al acceder a este sitio web y/o adquirir el e-book "Facebook Ads
          Andrómeda: 10 Secretos para NO Botar Tu Dinero", aceptas los
          siguientes términos y condiciones.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-102">
          1. Producto Digital
        </h3>
        <p data-id="element-103">
          El producto ofrecido es un e-book digital en formato electrónico. Una
          vez completada la compra, recibirás acceso inmediato al contenido a
          través de la plataforma Hotmart.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-104">
          2. Uso del Producto
        </h3>
        <p data-id="element-105">
          El e-book es para uso personal y educativo. Queda estrictamente
          prohibido:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-106">
          <li data-id="element-107">
            Reproducir, distribuir o compartir el contenido sin autorización
          </li>
          <li data-id="element-108">Revender o redistribuir el producto</li>
          <li data-id="element-109">
            Utilizar el contenido para crear productos derivados sin permiso
          </li>
        </ul>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-110">
          3. Resultados
        </h3>
        <p data-id="element-111">
          Los resultados obtenidos al aplicar las estrategias del e-book pueden
          variar según múltiples factores, incluyendo pero no limitado a: tu
          industria, presupuesto, oferta, mercado objetivo y ejecución. No
          garantizamos resultados específicos de ingresos o rendimiento
          publicitario.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-112">
          4. Política de Reembolso
        </h3>
        <p data-id="element-113">
          Dado que se trata de un producto digital con acceso inmediato, las
          solicitudes de reembolso serán evaluadas caso por caso según las
          políticas de la plataforma Hotmart. Te recomendamos revisar las
          políticas de reembolso de Hotmart antes de realizar tu compra.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-114">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-115">
          Todo el contenido del e-book, incluyendo textos, gráficos, diseños y
          metodologías, está protegido por derechos de autor. La compra del
          e-book te otorga una licencia personal e intransferible para su uso.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-116">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-117">
          El contenido del e-book es de carácter educativo e informativo. No nos
          hacemos responsables por decisiones tomadas basándose en el contenido
          del producto, ni por pérdidas financieras derivadas de la
          implementación de las estrategias descritas.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-118">
          7. Modificaciones
        </h3>
        <p data-id="element-119">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en este sitio web.
        </p>

        <h3 className="text-white font-semibold text-base mt-6" data-id="element-120">8. Contacto</h3>
        <p data-id="element-121">
          Si tienes preguntas sobre estos términos de servicio, puedes
          contactarnos a través de nuestros canales oficiales de comunicación.
        </p>
      </Modal>
    </>;
}